import React from "react";
import { ReactComponent as MealIcon } from "../../../../../assects/svg/Insight/meal_icon.svg";
import { ReactComponent as WaterIcon } from "../../../../../assects/svg/Insight/water_icon.svg";
import { ReactComponent as SleepIcon } from "../../../../../assects/svg/Insight/sleep_icon.svg";
import { ReactComponent as GutIcon } from "../../../../../assects/svg/Insight/Gut_icon.svg";

interface WeekConsistency {
  score: number;
  meals: number;
  water: number;
  sleep: number;
  gut: number;
}

interface FortnightlyLogConsistencyProps {
  week1?: WeekConsistency;
  week2?: WeekConsistency;
}

const DEFAULT_WEEK1: WeekConsistency = { score: 40, meals: 80, water: 50, sleep: 100, gut: 20 };
const DEFAULT_WEEK2: WeekConsistency = { score: 75, meals: 80, water: 50, sleep: 100, gut: 20 };

const WeekColumn: React.FC<{ label: string; data: WeekConsistency }> = ({ label, data }) => {
  const metrics = [
    { label: "Meals", value: data.meals, Icon: MealIcon },
    { label: "Water", value: data.water, Icon: WaterIcon },
    { label: "Sleep", value: data.sleep, Icon: SleepIcon },
    { label: "Gut", value: data.gut, Icon: GutIcon },
  ];

  return (
    <div className="flex-1 flex flex-col">
      <div className="flex items-center justify-between px-4 py-2 bg-[#F5F6F7] rounded-md">
        <span className="text-[12px] 3xl:text-[13px] font-semibold text-[#1F1F1F] font-inter uppercase tracking-wider">
          {label}
        </span>
        <span className="text-[14px] 3xl:text-[16px] font-semibold text-[#1F1F1F] font-inter">
          {data.score}%
        </span>
      </div>
      <div className="flex flex-col">
        {metrics.map((m, i) => (
          <div
            key={m.label}
            className={`flex items-center justify-between px-4 py-2 ${
              i !== 0 ? "border-t border-[#F3F4F6]" : ""
            }`}
          >
            <div className="flex items-center gap-1.5">
              <m.Icon className="w-3.5 h-3.5 text-[#8D8D8D]" />
              <span className="text-[11px] 3xl:text-[12px] text-[#8D8D8D] font-inter">
                {m.label}
              </span>
            </div>
            <span className="text-[12px] 3xl:text-[14px] font-medium text-[#1F1F1F] font-inter">
              {m.value}%
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

const FortnightlyLogConsistency: React.FC<FortnightlyLogConsistencyProps> = ({
  week1 = DEFAULT_WEEK1,
  week2 = DEFAULT_WEEK2,
}) => {
  return (
    <div className="bg-white border border-[#F3F4F6] rounded-xl p-4 flex flex-col h-full">
      <span className="text-[12px] 3xl:text-[14px] font-semibold uppercase tracking-widest text-[#1F1F1F] font-inter mb-3">
        Log Consistency
      </span>
      <div className="flex gap-3">
        <WeekColumn label="Week 1" data={week1} />
        <WeekColumn label="Week 2" data={week2} />
      </div>
    </div>
  );
};

export default FortnightlyLogConsistency;
